import { defineStore } from 'pinia'
import { ApiCountry } from '@/types'
import { fetchCountries as apiCountries, CountryOptions } from '@services/api/options'
import { computed, ref } from 'vue'
import { useCachedRequest } from '@composables/useCachedRequest'

export const useCountryCachedStore = defineStore('countryCache', () => {
  const cacheKey = ref('country_cache')

  // TODO: fix to take in filters
  const g = async () => {
    const result = await apiCountries()
    if (!result.status) throw new Error(result.message)
    return result.data!
  }

  const { data: countries, error, message, isLoading, isReady } = useCachedRequest<ApiCountry[], string>(cacheKey, g)

  const lspApprovedCountries = computed(() => countries.value?.filter((c) => c.lspApproved == 1))

  const isCountryLSPApproved = computed(
    () => (countryCode: string) => lspApprovedCountries.value?.find((country) => country.countryCode == countryCode),
  )

  const countryName = computed(() => {
    return (countryCode: string) =>
      countries.value?.find((country) => country.countryCode == countryCode)?.countryName ?? countryCode
  })

  const fetchCountries = async () => {
    error.value = false
    isLoading.value = true
    console.log('here: 10')
    return async () => {
      const result = await apiCountries()
      console.log('here: 11')
      if (result.status) {
        countries.value = result.data ?? []
        console.log('here: 12')
      } else {
        error.value = true
        console.log('here: 13')
      }
      isLoading.value = false
      console.log('here: 14')
    }
  }

  return {
    countries,
    fetchCountries,
    lspApprovedCountries,
    isCountryLSPApproved,
    countryName,
    error,
    message,
    isLoading,
    isReady,
  }
})

export const useCountryStore = defineStore('country', {
  state: () => {
    return {
      countries: undefined as unknown as ApiCountry[],
      error: false,
      isLoading: false,
    }
  },
  getters: {
    countryName(state) {
      return (countryCode: string) =>
        state.countries?.find((country) => country.countryCode == countryCode)?.countryName ?? countryCode
    },
  },
  actions: {
    getLspApprovedCountries() {
      return this?.countries.filter((c) => c.lspApproved == 1)
    },
    isCountryLSPApproved(countryCode: string) {
      return this.getLspApprovedCountries()?.find((c) => c.countryCode == countryCode)
    },
    async fetchCountries(filters?: CountryOptions) {
      this.error = false
      this.isLoading = true
      const result = await apiCountries(filters)
      if (result.status) {
        this.countries = result.data ?? []
      } else {
        this.error = true
      }
      this.isLoading = false
    },
  },
})
